import { Suspense, lazy } from 'react';
import { LoadingView } from '@/components/LoadingView';
import { Navigate, Route, Routes } from 'react-router-dom';
import Contacts from '@/views/Contacts/Contacts';
const NotFound = lazy(() => import('../components/NotFound/NotFound'));
// const Dashboard = lazy(() => import('@/views/Dashboard/Dashboard'));
const Flywheel = lazy(() => import('@/views/Matters/Flywheel/Flywheel'));
const Matters = lazy(() => import('@/views/Matters/Matters'));
const Fees = lazy(() => import('@/views/Fees'));
const Expenses = lazy(() => import('@/views/Expenses'));
const Tasks = lazy(() => import('@/views/Tasks/Tasks'));
const BizDev = lazy(() => import('@/views/BizDev'));
const Invoices = lazy(() => import('@/views/Invoices/Invoices'));
const InvoiceDetail = lazy(() => import('@/views/Invoices/InvoiceDetail'));
const OpsHR = lazy(() => import('@/views/Financials/OpsHR'));
const Resources = lazy(() => import('@/views/KnowledgeBase/KnowledgeBase'));
const Wellness = lazy(() => import('@/views/Wellness'));
const Settings = lazy(() => import('@/views/Settings/Settings'));
const PractistAccount = lazy(
  () => import('@/views/PractistAccount/PractistAccount'),
);
const MatterDashboard = lazy(
  () => import('@/views/MatterDashboard/MatterDashboard'),
);
const ClaimsSpreadsheet = lazy(
  () => import('@/views/ClaimsSpreadsheet/ClaimsSpreadsheet'),
);
const MattersSpreadsheet = lazy(
  () => import('@/views/Matters/MattersSpreadsheet/MattersSpreadsheet'),
);
const FeeDetails = lazy(() => import('@/views/PaymentOnboarding/FeeDetails'));
const FormExpired = lazy(() => import('@/views/PaymentOnboarding/FormExpired'));
const FormSubmitted = lazy(
  () => import('@/views/PaymentOnboarding/FormSubmitted'),
);
const EmailAccount = lazy(() => import('@/views/EmailAccount/EmailAccount'));
const MySettings = lazy(() => import('@/views/MySettings/MySettings'));
const MySettingsCommunication = lazy(
  () => import('@/views/MySettings/MySettingsCommunication'),
);
const Chat = lazy(() => import('@/views/Chat/Chat'));
const DocGen = lazy(() => import('@/views/DocGen/DocGen'));

const AuthenticatedAppRoutes = () => {
  return (
    <Suspense fallback={<LoadingView />}>
      <Routes>
        <Route path='/' element={<Navigate to='/matters' />} />
        <Route path='/login' element={<Navigate to='/matters' />} />
        <Route path='/flywheel' element={<Flywheel />} />
        <Route path='/matters/:tab' element={<Matters />} />
        <Route path='/matters' element={<Matters />} />
        <Route path='/fees' element={<Fees />} />
        <Route path='/fees/:tab' element={<Fees />} />
        <Route path='/expenses' element={<Expenses />} />
        <Route path='/tasks' element={<Tasks />} />
        <Route path='/biz-dev' element={<BizDev />} />
        <Route path='/invoices' element={<Invoices />} />
        <Route path='/invoices/draft/:matterId' element={<InvoiceDetail />} />
        <Route path='/invoices/detail/:invoiceId' element={<InvoiceDetail />} />
        <Route path='/invoices/:tab' element={<Invoices />} />
        <Route path='/ops-hr' element={<OpsHR />} />
        <Route path='/ops-hr/:tab' element={<OpsHR />} />
        <Route path='/resources' element={<Resources />} />
        <Route path='/wellness' element={<Wellness />} />
        <Route path='/settings' element={<Settings />} />
        <Route path='/settings/:tab' element={<Settings />} />
        <Route path='/matter/:id/:tab' element={<MatterDashboard />} />
        <Route path='/matter/:id' element={<MatterDashboard />} />
        <Route path='/spreadsheet' element={<MattersSpreadsheet />} />
        <Route
          path='/claims'
          element={<Navigate to='/fees/insurance' replace />}
        />
        <Route path='/contacts/:tab' element={<Contacts />} />
        <Route path='/contacts' element={<Navigate to='/contacts/people' />} />
        <Route path='/chat' element={<Chat />} />
        <Route path='/docgen' element={<DocGen />} />
        <Route path='/practist-account' element={<PractistAccount />} />
        <Route path='/my-settings' element={<MySettings />} />
        <Route
          path='/my-settings/communication'
          element={<MySettingsCommunication />}
        />
        <Route path='/email-account' element={<EmailAccount />} />
        <Route path='/fee-details' element={<FeeDetails />} />
        <Route path='/form-expired' element={<FormExpired />} />
        <Route path='/form-submitted' element={<FormSubmitted />} />
        <Route path='*' element={<NotFound />} />
      </Routes>
    </Suspense>
  );
};

export default AuthenticatedAppRoutes;
